import * as fromDatatype from '../../../../../datatype-library/index';

//added interface and rowclass for container field because this does not exist as table in dbschema/database
export interface contact_merger_record_RowInterface {
    table_name: fromDatatype.VarcharDatatypeInterface;
    guid: fromDatatype.GuidDataFieldInterface;
    key_guid: fromDatatype.GuidDataFieldInterface;
    name: fromDatatype.VarcharDatatypeInterface;
    phone: fromDatatype.VarcharDatatypeInterface;
    email: fromDatatype.VarcharDatatypeInterface;
    id_no: fromDatatype.VarcharDatatypeInterface;
    id_type: fromDatatype.VarcharDatatypeInterface;
    ref_1: fromDatatype.VarcharDatatypeInterface;
    ref_2: fromDatatype.VarcharDatatypeInterface;
    ref_3: fromDatatype.VarcharDatatypeInterface;
    ref_4: fromDatatype.VarcharDatatypeInterface;
    ref_5: fromDatatype.VarcharDatatypeInterface;
    status: fromDatatype.StatusDataFieldInterface;
    order: fromDatatype.IntegerDatatypeClass;
}

export class contact_merger_record_RowClass implements contact_merger_record_RowInterface {
    table_name: fromDatatype.VarcharDatatypeInterface;
    guid: fromDatatype.GuidDataFieldInterface;
    key_guid: fromDatatype.GuidDataFieldInterface;
    name: fromDatatype.VarcharDatatypeInterface;
    phone: fromDatatype.VarcharDatatypeInterface;
    email: fromDatatype.VarcharDatatypeInterface;
    id_no: fromDatatype.VarcharDatatypeInterface;
    id_type: fromDatatype.VarcharDatatypeInterface;
    ref_1: fromDatatype.VarcharDatatypeInterface;
    ref_2: fromDatatype.VarcharDatatypeInterface;
    ref_3: fromDatatype.VarcharDatatypeInterface;
    ref_4: fromDatatype.VarcharDatatypeInterface;
    ref_5: fromDatatype.VarcharDatatypeInterface;
    status: fromDatatype.StatusDataFieldInterface;
    order: fromDatatype.IntegerDatatypeClass;
}
